import React from 'react'
import Typography, { TypographyProps } from '@material-ui/core/Typography'

interface ICaptionProp {
  children: string
}
export const Caption = ({
  children,
  ...props
}: TypographyProps & ICaptionProp) => (
  <Typography variant="caption" {...props}>
    {children}
  </Typography>
)
